import {
  getFiscalQuarterMonths,
  reportingMonthToFiscalYearQuarter,
  type FiscalQuarter,
  type ReportingMonth,
} from '../lib/reportingMonth';

export type ExportPeriod = 'monthly' | 'trimester' | 'year';

export type ExportPeriodContext = {
  period: ExportPeriod;
  reportingMonth: ReportingMonth;
  fiscalYear: number;
  fiscalQuarter?: FiscalQuarter;
  months: ReportingMonth[];
  startDate: Date;
  endDate: Date;
};

const endOfMonth = (year: number, month: number): Date =>
  new Date(year, month, 0, 23, 59, 59, 999);

const monthStart = (monthKey: ReportingMonth): Date => {
  const [yearText, monthText] = monthKey.split('-');
  return new Date(Number(yearText), Number(monthText) - 1, 1);
};

const monthEnd = (monthKey: ReportingMonth): Date => {
  const [yearText, monthText] = monthKey.split('-');
  return endOfMonth(Number(yearText), Number(monthText));
};

const fiscalYearMonths = (fiscalYearCe: number): ReportingMonth[] => [
  `${fiscalYearCe - 1}-10`,
  `${fiscalYearCe - 1}-11`,
  `${fiscalYearCe - 1}-12`,
  `${fiscalYearCe}-01`,
  `${fiscalYearCe}-02`,
  `${fiscalYearCe}-03`,
  `${fiscalYearCe}-04`,
  `${fiscalYearCe}-05`,
  `${fiscalYearCe}-06`,
  `${fiscalYearCe}-07`,
  `${fiscalYearCe}-08`,
  `${fiscalYearCe}-09`,
] as ReportingMonth[];

export function getExportPeriodContext(
  period: ExportPeriod,
  reportingMonth: ReportingMonth,
): ExportPeriodContext {
  const { fiscalYear: fiscalYearCe, quarter } = reportingMonthToFiscalYearQuarter(reportingMonth);
  const fiscalYear = fiscalYearCe + 543;

  if (period === 'monthly') {
    return {
      period,
      reportingMonth,
      fiscalYear,
      months: [reportingMonth],
      startDate: monthStart(reportingMonth),
      endDate: monthEnd(reportingMonth),
    };
  }

  if (period === 'trimester') {
    const months = getFiscalQuarterMonths(reportingMonth);
    return {
      period,
      reportingMonth,
      fiscalYear,
      fiscalQuarter: quarter,
      months,
      startDate: monthStart(months[0]),
      endDate: monthEnd(months[months.length - 1]),
    };
  }

  const months = fiscalYearMonths(fiscalYearCe);
  return {
    period,
    reportingMonth,
    fiscalYear,
    months,
    startDate: monthStart(months[0]),
    endDate: monthEnd(months[months.length - 1]),
  };
}
